import getPlatform from './helpers/getPlatform'

export const ACTIONS = {
  SCREEN_VIEW: 'Screen Viewed',
  BUTTON_TAPPED: 'Button Tapped',
}

export const OPTIONS = {
  INTRO: { context: 'intro', position: '0' },
  TABLE_OF_CONTENT: { context: 'tableOfContent', position: '1' },
  CONTRIBUTIONS: { context: 'contributions', position: '2' },
  GIFTS: { context: 'gifts', position: '3' },
  PERFORMANCE: { context: 'performance', position: '4' },
  STOCKS: { context: 'stocks', position: '5' },
  POTENTIAL: { context: 'potential', position: '6' },
}

const getBaseAnalyticsOptions = () => ({
  feature: 'Early Quarterly Recaps',
  investment_product: ['early'],
  platform: getPlatform(),
  screen: 'earlyQuarterlyRecaps',
  screen_name: 'earlyQuarterlyRecaps',
  segment_call_type: 'track',
})

export const baseAnalyticsOptions = getBaseAnalyticsOptions()

const getShareAnalyticsOptions = () => ({
  action: 'Tapped',
  event_description: 'Early Quarterly Recaps Share CTA Tapped',
  feature: 'Early Quarterly Recaps',
  investment_product: ['early'],
  object: 'Button',
  object_name: 'earlyQuarterlyRecapShareCTA',
  origin: ['early_recaps'],
  platform: getPlatform(),
  screen: 'earlyQuarterlyRecaps',
  screen_name: 'earlyQuarterlyRecap',
  segment_call_type: 'track',
})

export const shareAnalyticsOptions = getShareAnalyticsOptions()

export const SECTION_NAMES = {
  CONTRIBUTIONS: 'contributions',
  DISCLOSURE: 'disclosure',
  GIFTS: 'gifts',
  PERFORMANCE: 'performance',
  POTENTIAL: 'potential',
  STOCKS: 'stocks',
}
